import {Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import * as _moment from 'moment';
const moment = _moment;
import * as _ from "lodash";
import {NzFormatEmitEvent, NzTreeNode} from "ng-zorro-antd/tree";
import {NzModalService} from "ng-zorro-antd/modal";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzContextMenuService, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import { EntityManagementSupportComponent } from '../../../tools/entity-management-support/entity-management-support.component';

@Component({
  selector: 'pi-function-management',
  templateUrl: './function-management.component.html',
  styleUrls: ['./function-management.component.css']
})
export class FunctionManagementComponent extends EntityManagementSupportComponent implements OnInit, OnChanges {
  @ViewChild('modalContent') modalContent;
  @Input() dataList;
  @Output() cloneAction = new EventEmitter();
  @Output() removeAction = new EventEmitter();
  @Output() saveAction = new EventEmitter();
  searchText;
  avaliableParentsSelectList = [];
  operationMode: 'normal' | 'copy' = 'normal';
  unAvaliableParentsSelectList = [];
  nodes = [];
  activatedNode: NzTreeNode;
  currentFunGroup;
  inProcess = false;
  detailForm: FormGroup;
  expandMap = {};

  constructor(
    public modalService: NzModalService,
    public notification: NzNotificationService,
    public translateService: TranslateService,
    private nzContextMenuService: NzContextMenuService,
    private fb: FormBuilder,
    public injector: Injector
  ) {
    // super(translateService, modalService);
    super(injector);
    this.detailForm = this.fb.group({
      functionCode: [null, [Validators.required]],
      functionName: [null, [Validators.required]],
      functionDomain: [null],
      functionType: [null, [Validators.required]],
      businessType: [null],
      displayOrder: [1],
      displayed: [true],
      functionIconUri: [null],
      functionImageUri: [null],
      functionRequestMethod: [null],
      functionParam1: [null],
      functionParam2: [null],
      functionParam3: [null],
      functionParam4: [null],
      functionParam5: [null],
      functionParamDesc1: [null],
      functionParamDesc2: [null],
      functionParamDesc3: [null],
      functionParamDesc4: [null],
      functionParamDesc5: [null],
      functionUri: [null],
      functionUriParams: [null],
      parentId: [null],
    });
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataList) {
      this.buildData();
    }
  }

  buildData() {
    const nodes = [];
    this.dataList.forEach(d => {
      nodes.push({
        title: d.functionName,
        key: d.id,
        id: d.id,
        metaData: d,
        icon: d.functionIconUri === undefined ? '' : d.functionIconUri,
        expanded: this.expandMap[d.id] || false, // d.functionType === 'SYS' ? true : false,
        isLeaf: true
      });
    });
    this.nodes = this.buildTree(nodes);
  }

  checkExpandStatus($event) {
    const expandedIds = $event.keys;
    this.expandMap = {};
    expandedIds.forEach(id => {
      this.expandMap[id] = true;
    })
    console.log(this.expandMap);
  }

  buildTree(list) {
    const map = {};
    let node;
    const roots = [];
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i; // initialize the map
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.metaData.parentId !== -1) {
        // if you have dangling branches check that map[node.parentId] exists
        // list[map[node.metaData.parentId]].isLeaf = false;
        const targetOrder = list[map[node.metaData.parentId]];
        if (targetOrder) {
          if (!targetOrder.children) {
            targetOrder.children = [];
          }
          targetOrder.children.push(node);
          targetOrder.children.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
          targetOrder.isLeaf = false;
        } else {
          roots.push(node);
          roots.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
        }
      } else {
        roots.push(node);
        roots.sort((a, b) => a.metaData.displayOrder - b.metaData.displayOrder);
      }
    }
    const endTime = new Date().getTime();
    return roots;
  }

  getUnAvaliableParentsSelectList(currentItemId) { // 获取不可成为父功能的id集合
    let arr = [];
    arr = this.dataList.filter(d => d.parentId === currentItemId); // arr = 当前currentItemId子功能的id集合
    arr.forEach(a => { // 如果arr里的子功能还有子功能，则继续循环深入
      if (this.unAvaliableParentsSelectList.indexOf(a.id) === -1) {
        this.unAvaliableParentsSelectList.push(a.id);
      }
      this.getUnAvaliableParentsSelectList(a.id);
    });
  }

  add() {
    this.operationMode = 'normal';
    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = []; // 每次getUnAvaliableParentsSelectList之前init this.unAvaliableParentsSelectList为空数组
    this.getUnAvaliableParentsSelectList(undefined);
    this.currentFunGroup = {};
    this.detailItem = {};
  }

  async modify(item) {
    this.operationMode = 'normal';
    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = []; // 每次getUnAvaliableParentsSelectList之前init this.unAvaliableParentsSelectList为空数组
    this.getUnAvaliableParentsSelectList(item.id);
    this.avaliableParentsSelectList = this.avaliableParentsSelectList.filter(a => a.id !== item.id
      && this.unAvaliableParentsSelectList.indexOf(a.id) === -1);
    this.detailItem = {... item};
  }

  copyFunction(item) {
    const copyItem = _.cloneDeep(item);
    copyItem.functionName = copyItem.functionName + ' 副本';
    this.cloneAction.emit(item);
  }

  async remove(item) {
    this.removeAction.emit(item);
  }

  async save() {
    const saveObj = {... this.detailItem};
    for (const i in this.detailForm.controls) {
      this.detailForm.controls[i].markAsTouched();
      this.detailForm.controls[i].updateValueAndValidity();
    }
    if (this.detailForm.valid) {
      this.saveAction.emit(this.dataProcessBeforeSave(saveObj))
    }
  }

  dataProcessBeforeSave(item) {
    if (!item.id) {
      item.departmentId = -1;
      item.organizationId = -1;
      item.displayOrder = item.displayOrder != undefined ? item.displayOrder : 1;
      item.displayed = true;
    }

    if (!item.parentId) {
      item.parentId = -1;
    }
    return item;
  }

  activeNode(data: NzFormatEmitEvent): void {
    this.activatedNode = data.node!;
    this.currentFunGroup = data.node.origin.metaData;
    this.detailItem = _.cloneDeep(data.node.origin.metaData);

    this.avaliableParentsSelectList = _.cloneDeep(this.dataList);
    this.unAvaliableParentsSelectList = [];
    this.getUnAvaliableParentsSelectList(data.node.origin.id);
    this.avaliableParentsSelectList = this.avaliableParentsSelectList.filter(a => a.id !== data.node.origin.id
      && this.unAvaliableParentsSelectList.indexOf(a.id) === -1);
  }

  openFolder(data: NzTreeNode | NzFormatEmitEvent): void {
    // do something if u want
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
  }

  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent, metaData): void {
    this.nzContextMenuService.create($event, menu);
    this.detailItem = _.cloneDeep(metaData);
    this.currentFunGroup = metaData;
  }

  onChange(event) {

  }
}
